require('bijou/base')

(($) ->

  $.widget "bijou.cover_question", $.bijou.base,

    _create: ->
      cover_limit_question = @element.next()
      select_field = cover_limit_question.find('select')

      show_cover_limit = select_field.val() not in ['', '0']
      question_off = @element.hasClass('off')

      hidden_input = $('<input type="hidden">')
      hidden_input
        .attr('name', select_field.attr('name'))
        .val('0')
        .prop('disabled', (show_cover_limit || question_off))
        .appendTo(@element)

      select_field
        .prop('disabled', !show_cover_limit)
        .find('option').eq(1).remove()

      radio_buttons = @element.find(':radio')
      yes_radio_button = radio_buttons.first()

      cover_limit_question.on 'questionShow', (e) ->
        e.preventDefault() unless yes_radio_button[0].checked

      radio_buttons.on 'change', =>
        if yes_radio_button[0].checked
          hidden_input.prop('disabled', true)
          @options.form.smart_form('toggleQuestion', cover_limit_question, true)
        else
          hidden_input.prop('disabled', false)
          @options.form.smart_form('toggleQuestion', cover_limit_question, false)
          for question in cover_limit_question.nextAll('.control-block')
            @options.form.smart_form('toggleQuestion', $(question), false)
          select_field.prop('disabled', true).trigger('change')

) window.jQuery
